import { MDSTextFieldSlotName, MDSTextFieldVariant } from "@/mds/components/forms/text-field";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { StyledSearchInput, StyledWrapper } from "./menu-input-header.styles";
import { MDSMenuInputHeaderProps, KeyDirection } from "./menu-input-header.types";

/**
 * MDSMenuInputHeader should be used outside of an MDSMenu
 * react-aria automatically uses type-ahead to focus inputs within the list and will interfere with the input
 */
export const MDSMenuInputHeader = ({
  onChange,
  value,
  placeholder,
  onKeyDirection,
  onEscape,
  onEnter,
  onClear,
}: MDSMenuInputHeaderProps) => {
  return (
    <StyledWrapper>
      <StyledSearchInput
        variant={MDSTextFieldVariant.Form}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        autoFocus={true}
        showClearTextButton={true}
        onClearText={onClear}
        onKeyDown={e => {
          switch (e.key) {
            case "ArrowUp":
              e.preventDefault();
              onKeyDirection?.(KeyDirection.UP);
              return true;
            case "ArrowDown":
              e.preventDefault();
              onKeyDirection?.(KeyDirection.DOWN);
              return true;
            case "Escape":
              e.preventDefault();
              onEscape?.();
              return true;
            case "Enter":
            case "Return":
              e.preventDefault();
              onEnter?.();
              return true;
          }
        }}
      >
        <MDSIcon kind={MDSIconKind.Search} slot={MDSTextFieldSlotName.LeftAddon} />
      </StyledSearchInput>
    </StyledWrapper>
  );
};
